export default "__VITE_ASSET__BQTkj5rR__"